<div class="row my-5">
  <div class="col-12 text-center text-muted">
    <i class="fa fa-spinner fa-2x fa-spin"></i>
    <br/>Загрузка...
  </div>
</div>
